import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ChangeDetectorRef, NgZone, Input } from '@angular/core';
import { AuftragEx, Eigenschaft, AuftragspositionEx, NfcEvent, ReCoMobilEigenschaftEx } from 'src/app/api/model/model';
import { AlertController, ModalController, IonSelect, IonSearchbar } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { Subscription, BehaviorSubject } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Artikel, AdresseEntity, UvvPruefGegenstand, Auftragsposition, GpsPosition, MengeOptionTyp, Vertragsposition, Vertrag, Wiegedaten, AuftragsFormular, Auftragstyp, ReCoMobilBehaelterbewegung, Textdatei, TextdateiTyp } from 'src/app/api/model/swagger-model';
import { ClickHelper } from 'src/app/api/helper/click-helper';
import { TranslateService } from '@ngx-translate/core';
import { UvvService } from 'src/app/api/uvv.service';
import { UvvHelper } from 'src/app/api/helper/uvv-helper';
import { StringHelper } from 'src/app/api/helper/string-helper';
import { UvvPruefungModalPage } from 'src/app/shared/modal/uvv-pruefung-modal/uvv-pruefung-modal.page';
import { AppConfig } from 'src/app/api/helper/app.config';
import { AuftragArtikelAuswahlPage } from '../artikel-auswahl/artikel-auswahl.component';
import { BarcodeAuthGuard } from 'src/app/shared/barcode.guard';
import { SystemService } from 'src/app/api/system.service';
import { WaageService } from 'src/app/api/waage.service';
import { Utils } from 'src/app/api/helper/utils';
import { delay } from 'rxjs/operators';
import { IAuftragdetails } from '../auftragdetails/iauftragdetails';
import { Constants } from 'src/app/api/model/constants';
import { AuftragHelper } from 'src/app/api/helper/auftrag-helper';
import { I18N } from 'src/app/api/helper/i18n';
import { getWaageModusInfo } from 'src/app/api/waagen/waage-modus.helper';

import moment from 'moment';
import { App } from '@capacitor/app';

const log = new Logger("AuftragLieferungDetailsPage");

@Component({
    selector: 'app-auftrag-lieferung-details',
    templateUrl: './auftrag-lieferung-details.page.html',
    styleUrls: ['./auftrag-lieferung-details.page.scss'],
    standalone: false
})
export class AuftragLieferungDetailsPage implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('content', { static: false }) content: any;
    @ViewChild('wiegungenSelect', { read: IonSelect, static: false }) wiegungenSelect: IonSelect;
    @ViewChild('searchbar', { static: false }) searchbar: IonSearchbar;

    @Input() auftrag: AuftragEx;
    @Input() auftragdetails: IAuftragdetails;
    @Input() artikelHinzufuegenButtonAnzeigen = false;
    @Input() plusMinusButtonAnzeigen = true;

    /**
     * Wrid gefüllt, wenn nur genau eine Auftragsposition bearbeitet werden soll.
     * Ansonsten ist das null.
     */
    @Input() auftragsposition: AuftragspositionEx;

    subscriptions: Subscription[] = [];
    artikelList: Artikel[] = [];
    abstellortListe: AdresseEntity[] = [];
    formularKonfiguration: AuftragsFormular;
    isBarcodeFeld = false;
    allePositionen: AuftragspositionVO[] = [];
    sichtbarePositionen: AuftragspositionVO[] = [];
    barcodeZiel: any = null;
    barcodeZielTyp = '';
    barcodeZielAuftragsposition: AuftragspositionVO = null;
    behaelterBarcodeButtonSichtbar = true;
    behaelterNfcButtonSichtbar = true;
    istAuftragReadOnly = false;
    positionHinzufuegenErlaubt = new BehaviorSubject<boolean>(true);
    plusMinusButtons = false;
    laderaeume: LaderaumVO[] = [];
    laderaumAuswahlAktiv = false;
    behaelterNummerNurZiffern = false;
    isPositionDruckenMoeglich = false;
    isBehaelterNummerReadOnly = false;

    searchbarSichtbar = new BehaviorSubject<boolean>(false);
    suchtext = '';

    nfcAlert: HTMLIonAlertElement = null;
    nfcAktiv = false;
    sollMengeAnzeigen = false;

    dayNames = Constants.dayNames;
    uvvPruefungModal: HTMLIonModalElement;
    wiegedatenListe: Wiegedaten[] = [];
    wiegungAuswahlAuftragsposition: AuftragspositionVO;

    positionsEigenschaftenImmerAnzeigen = false;

    /** Zeigt einen eigenen Button zum Ändern des Artikels an, statt nur die Bezeichnung anklickbar zu machen. */
    artikelAendernButtonAnzeigen = false;

    title = new BehaviorSubject('Lieferung');

    app = MyApp.current;
    nfcRegistrationId: number;

    isLeerePositionenAusblenden = false;
    anzahlPositionAusgeblendet = 0;
    anzahlLeerePositionenWerdenAngezeigt = 0;
    isLeerePositionAnzeigen = false;

    constructor(
        private auftragService: AuftragService,
        private uvvService: UvvService,
        private modalController: ModalController,
        private stammdatenService: StammdatenService,
        private systemService: SystemService,
        private alertController: AlertController,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private waageService: WaageService,
        private translate: TranslateService) {

    }

    async ngOnInit() {
        log?.debug('ngOnInit');

        MyApp.current.klingelnBlockiert.next(true);

        this.behaelterNummerNurZiffern = AppConfig.current.einstellungen.BehaelterNummerNurZiffern === 'ja';
        this.sollMengeAnzeigen = AppConfig.current.einstellungen.TransportauftragMengeSollAnzeigen === 'ja';

        if (this.auftrag == null) {
            UiHelper.showError('Auftrag nicht gesetzt');
            return;
        }

        await this.auftragdetails.pruefeZeiterfassungGestartet();

        this.isBehaelterNummerReadOnly = false;

        switch (this.auftrag.Auftragstyp) {
            case Auftragstyp.Transportauftrag:
                this.positionHinzufuegenErlaubt.next(AppConfig.current.einstellungen.TransportauftraegePositionHinzufuegenErlaubt === 'ja');
                this.isBehaelterNummerReadOnly = AppConfig.current.einstellungen.TransportauftraBehaelterNummerHandeingabeErlaubt === 'nein';
                this.isLeerePositionenAusblenden = Utils.isTrue(AppConfig.current.einstellungen.TransportauftragLeerePositionenAusblenden);
                break;

            case Auftragstyp.Hofchecker:
                this.positionHinzufuegenErlaubt.next(AppConfig.current.einstellungen.HofauftraegePositionHinzufuegenErlaubt === 'ja');
                break;

            case Auftragstyp.Kommissionierung:
                this.positionHinzufuegenErlaubt.next(AppConfig.current.einstellungen.KommissionierungPositionHinzufuegenErlaubt === 'ja');
                break;

            case Auftragstyp.Wareneingang:
                this.positionHinzufuegenErlaubt.next(true); // TODO: Eventuell konfigurierbar machen
                this.isPositionDruckenMoeglich = true;
                break;
        }

        if (this.auftragdetails.isLieferungAendernGesperrt) {
            this.positionHinzufuegenErlaubt.next(false);
        }

        this.positionsEigenschaftenImmerAnzeigen = AppConfig.current.einstellungen.PositionsEigenschaftenImmerAnzeigen === 'ja';

        // Default ist bewusst 'nein', damit sich die Darstellung bei bestehenden Mandanten nicht ungefragt ändert.
        this.artikelAendernButtonAnzeigen = AppConfig.current.einstellungen.AuftragArtikelAendernButtonAnzeigen === 'ja';

        this.formularKonfiguration = await this.stammdatenService.getAuftragsFormularKonfiguration(this.auftrag);

        this.title.next(Utils.getEinstellung(this.formularKonfiguration, 'Lieferung', 'Titel', 'Lieferung'));

        this.istAuftragReadOnly = this.auftragdetails.isLieferungAendernGesperrt;

        this.behaelterNfcButtonSichtbar = MyApp.current.behaelterMitNfc.getValue();
        this.behaelterBarcodeButtonSichtbar = MyApp.current.behaelterMitBarcode.getValue();

        await this.ladeAbstellorte();

        this.laderaeume = [];

        if (this.auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
            this.laderaumAuswahlAktiv = AppConfig.current.einstellungen.TransportauftragLaderaumAuswahlAktiv === 'ja';

            if (this.laderaumAuswahlAktiv) {
                const fahrzeug = MyApp.current.fahrzeug.getValue();

                if (fahrzeug && fahrzeug.Laderaeume && fahrzeug.Laderaeume.length > 1) {
                    for (const laderaum of fahrzeug.Laderaeume) {
                        const vo: LaderaumVO = {
                            key: fahrzeug.key + '-' + laderaum.Nummer,
                            nummer: laderaum.Nummer,
                            bezeichnung: laderaum.Nummer + ': ' + laderaum.Bezeichnung
                        };

                        if (!vo.bezeichnung) {
                            vo.bezeichnung = laderaum.Nummer.toString();
                        }

                        this.laderaeume.push(vo);
                    }
                } else {
                    this.laderaumAuswahlAktiv = false;
                }
            }
        }

        this.artikelList = this.stammdatenService.getAlleArtikel().getValue();

        this.updatePositionen();

        await this.ladeArtikelListe();

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'lieferung');

        this.nfcRegistrationId = this.systemService.registerNfcReceiver(0, (nfcEvent) => this.verarbeiteNfcEvent(nfcEvent));

        this.subscriptions.push(this.auftragdetails.beaforePageLeave.subscribe(() => this.onBeforePageLeave()));
        this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(info => { this.detectChanges(); }));
    }

    private updatePositionen() {
        log?.debug('updatePositionen');

        let artikelAenderbar = false;

        if (this.auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
            artikelAenderbar = AppConfig.current.einstellungen.TransportauftragArtikelAendern === 'ja';
        } else if (this.auftrag.Auftragstyp === Auftragstyp.Hofchecker) {
            artikelAenderbar = AppConfig.current.einstellungen.HofauftragArtikelAendern === 'ja';
        } else if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
            artikelAenderbar = AppConfig.current.einstellungen.KommissionierungArtikelAendern === 'ja';
        } else if (this.auftrag.Auftragstyp === Auftragstyp.Wareneingang) {
            artikelAenderbar = true; // TODO: eventuell konfigurierbar machen
        }

        this.allePositionen = [];

        for (const position of this.auftrag.Positionen) {
            const vo: AuftragspositionVO = {
                auftragsposition: position,
                artikel: {
                    artikelKey: position.ArtikelKey as any,
                    bezeichnung: position.Bezeichnung,
                    einheit: position.Einheit,
                },
                behaelter: null,
                mengeUngueltig: false,
                gewichtUngueltig: false,
                StandardMenge: position.StandardMenge,
                MengeOption: position.MengeOption,
                wiegungZuordnenAnzeigen: false,
                wiegenButtonAnzeigen: false,
                LaderaumAuswahlAktiv: false,
                suchtext: '',
                wiegenAktiv: false,
                isArtikelAenderbar: artikelAenderbar || position.IstNeu,
                isLoeschbar: this.auftragdetails.istPositionLoeschbar(position),
                mengeVariante: 'aenderbar'
            };

            if (!position.Eigenschaften) {
                position.Eigenschaften = [];
            }

            if (vo.MengeOption == 1) {
                vo.mengeVariante = 'standard-oder-null';

                if (!vo.StandardMenge) {
                    vo.StandardMenge = this.auftragService.getStandardMenge(vo.auftragsposition);
                }
            } else if (vo.MengeOption == 2) {
                vo.mengeVariante = 'nicht-aenderbar';
            }

            const eigenschaftenUppercase = AppConfig.current.einstellungen.AlleEigenschaftenUppercase === 'ja';

            for (const eigenschaft of position.Eigenschaften) {
                if (!eigenschaft.Typ) {
                    eigenschaft.Typ = 'text';
                }

                if (eigenschaftenUppercase) {
                    eigenschaft.Uppercase = true;
                }
            }

            // Hier extra mit == prüfen. Kann Zahl oder String sein
            const artikel = this.artikelList.find(p => p.artikelKey == vo.artikel.artikelKey);

            if (artikel) {
                // MengeOption
                switch (AppConfig.current.einstellungen.DatenherkunftMengeOption) {
                    case 'auftrag':
                        // Keine Änderung
                        break;

                    case 'artikel':
                        vo.MengeOption = artikel.MengeOption;
                        break;

                    default:
                        if (vo.MengeOption === null || typeof (vo.MengeOption) === 'undefined') {
                            vo.MengeOption = artikel.MengeOption;
                        }
                        break;
                }

                // StandardMenge
                switch (AppConfig.current.einstellungen.DatenherkunftStandardMenge) {
                    case 'auftrag':
                        // Keine Änderung
                        break;

                    case 'artikel':
                        vo.StandardMenge = artikel.StandardMenge;
                        break;

                    default:
                        if (vo.StandardMenge === null || typeof (vo.StandardMenge) === 'undefined') {
                            vo.StandardMenge = artikel.StandardMenge;
                        }
                        break;
                }

                // AuftragWiegungAktiv
                switch (AppConfig.current.einstellungen.DatenherkunftAuftragWiegungAktiv) {
                    case 'auftrag':
                        // Keine Änderung
                        break;

                    case 'artikel':
                        position.AuftragWiegungAktiv = artikel.AuftragWiegungAktiv;
                        vo.wiegenButtonAnzeigen = true;
                        break;

                    default:
                        if (position.AuftragWiegungAktiv === null || typeof (position.AuftragWiegungAktiv) === 'undefined') {
                            position.AuftragWiegungAktiv = artikel.AuftragWiegungAktiv;
                            vo.wiegenButtonAnzeigen = true;
                        }
                        break;
                }

                // LaderaumAuswahlAktiv
                switch (AppConfig.current.einstellungen.DatenherkunftLaderaumAuswahlAktiv) {
                    case 'auftrag':
                        // Keine Änderung
                        break;

                    case 'artikel':
                        vo.LaderaumAuswahlAktiv = artikel.LaderaumAuswahlAktiv;
                        break;

                    default:
                        if (this.laderaumAuswahlAktiv && artikel.LaderaumAuswahlAktiv) {
                            if (position.LaderaumAuswahlAktiv === null || typeof (position.LaderaumAuswahlAktiv) === 'undefined') {
                                // Nicht in Auftragsposition definiert, aber im Artikel.
                                // übernehme deshalb den Wert vom Artikel
                                vo.LaderaumAuswahlAktiv = true;
                            }
                        }
                        break;
                }

                // SeriennummerErforderlich
                switch (AppConfig.current.einstellungen.DatenherkunftSeriennummerErforderlich) {
                    case 'auftrag':
                        // Keine Änderung
                        break;

                    case 'artikel':
                        position.SeriennummerErforderlich = artikel.SeriennummerErforderlich;
                        break;

                    default:
                        if (artikel.SeriennummerErforderlich) {
                            if (position.SeriennummerErforderlich === null || typeof (position.SeriennummerErforderlich) === 'undefined') {
                                position.SeriennummerErforderlich = artikel.SeriennummerErforderlich;
                            }
                        }
                        break;
                }

                if (this.auftrag.Auftragstyp === Auftragstyp.Kommissionierung) {
                    // Chargenpflicht kommt immer aus dem Artikel
                    // Derzeit nur für Kommissionierungs-Aufträge setzen.
                    // Wird sonst nirgends benötigt
                    position.Chargenpflicht = artikel.Chargenpflicht;
                }
            }

            // Wird in RCL gefüllt aus Artikel "Wiegemöglichkeit auf App aktivieren"
            if (position.AuftragWiegungAktiv) {
                if (this.auftrag.Auftragstyp === Auftragstyp.Transportauftrag) {
                    vo.wiegenAktiv = AppConfig.current.einstellungen.TransportauftragPositionWiegenVerfuegbar === 'ja';
                } else if (this.auftrag.Auftragstyp === Auftragstyp.Hofchecker) {
                    vo.wiegenAktiv = AppConfig.current.einstellungen.HofauftraegePositionWiegenVerfuegbar === 'ja';
                }
            }

            if (MyApp.current.waageVerfuegbar.getValue()) {
                // TODO: Klären wann Wiegungen zugeordnet werden können
                // Für STAMPFL konnten früher die Wiegungen zu allen Positionen zugeordnet werden.
                // Für HUBERT SCHMID haben wir das umgebaut, so dass nur noch Positionen mit "AuftragWiegungAktiv" erlaubt sind.
                // Muss noch bei STAMPF getestet werden (11.01.2023)
                // Muss beim STAMPF und HUBERT SCHMID geprüft werden
                // Das Verhalten war hier davor so, dass Wiegungen zu allen Positionen zugeordnet werden konnten.

                vo.wiegungZuordnenAnzeigen = false;
                vo.wiegenButtonAnzeigen = false;

                if (position.AuftragWiegungAktiv) {
                    if (getWaageModusInfo().wiegenDurchApp) {
                        // Die Wiegung erfolgt aus der App heraus.
                        // Diese Funktion wurde für OFK implementiert.
                        // Es soll ein Button angezeigt werden, mit dem sich ein separates Popup öffnet.
                        // Mit dem Öffnen des Popups wird die Verbindung zur Waage hergestellt und der Wiegemodus auf der Waage gestartet.
                        // Im Modus 'beides' wird das Zuordnen offener Wiegungen ebenfalls in diesem Popup angeboten,
                        // damit der Fahrer beides an einer Stelle hat.
                        vo.wiegenButtonAnzeigen = true;
                    } else {
                        // Die Wiegungen werden zugeordnet.
                        vo.wiegungZuordnenAnzeigen = true;
                    }
                }

                // wollen das auch über die Wiegung steuern
                // if (AppConfig.current.einstellungen.WaagenTyp === 'bosche') {
                //     vo.wiegungZuordnenAnzeigen = true; // FIXME
                // }
            }

            if (this.laderaumAuswahlAktiv) {
                if (position.LaderaumAuswahlAktiv) {
                    vo.LaderaumAuswahlAktiv = true;
                }
            }

            this.updateSeriennummern(vo);
            this.updateBehaelter(vo);
            this.validiereMenge(vo);
            this.validiereGewicht(vo);

            this.updateAuftragsposition(vo);

            vo.suchtext = `${position.PosNr};${position.Bezeichnung};${position.ArtikelKey};${position.Einheit}`

            if (vo.behaelter) {
                for (const b of vo.behaelter) {
                    if (b.behaelterNr) {
                        vo.suchtext += ';' + b.behaelterNr;
                    }
                    if (b.manuelleNummer) {
                        vo.suchtext += ';' + b.manuelleNummer;
                    }
                    if (b.zustand) {
                        vo.suchtext += ';' + b.zustand;
                    }
                }
            }

            if (!vo.auftragsposition.Eigenschaften) {
                vo.auftragsposition.Eigenschaften = [];
            }

            for (const e of vo.auftragsposition.Eigenschaften) {
                if (e.Bezeichnung) {
                    vo.suchtext += ';' + e.Bezeichnung;
                }
                if (e.Wert) {
                    vo.suchtext += ';' + e.Wert;
                }
            }

            vo.suchtext = vo.suchtext.toLowerCase();

            this.allePositionen.push(vo);
        }

        this.filterSichtbareAuftragspositionen();

        this.detectChanges();
    }

    updateSeriennummern(vo: AuftragspositionVO) {
        const position = vo.auftragsposition;

        if (vo.auftragsposition?.SeriennummerErforderlich) {
            if (!position.Elemente) {
                position.Elemente = [];
            }
        } else {
            position.Elemente = [];
            return;
        }

        let anzahl = Math.ceil(vo.auftragsposition.Menge);

        if (anzahl > 100) {
            anzahl = 100;
        }

        if (position.Elemente.length > anzahl) {
            position.Elemente = position.Elemente.filter(p => p.Nummer);
        }

        while (position.Elemente.length < anzahl) {
            position.Elemente.push({ Pos: 0, Typ: 'Seriennummer' });
        }

        for (let i = 0; i < position.Elemente.length; i++) {
            const element = position.Elemente[i];
            element.Pos = i + 1;
        }
    }

    onMengeGeaendert(vo: AuftragspositionVO) {
        log?.debug('onMengeGeaendert: ' + vo.auftragsposition.Menge);

        if (vo.auftragsposition.Menge != null) {
            vo.auftragsposition.Menge = Utils.parseFloat(vo.auftragsposition.Menge);

            this.updateBehaelter(vo);
            this.updateSeriennummern(vo);
        }

        vo.auftragsposition.MengeIst = vo.auftragsposition.Menge;

        this.validiereMenge(vo);
        this.validiereGewicht(vo);

        this.auftragdetails.starteAuftragWennErforderlich('Menge geändert');
    }

    onGewichtGeaendert(vo: AuftragspositionVO) {
        log?.debug('onGewichtGeaendert');

        if (this.auftragdetails) {
            this.auftragdetails.starteAuftragWennErforderlich('onGewichtGeaendert');
        }

        this.validiereGewicht(vo);
    }

    onLaderaumGeaendert(vo: AuftragspositionVO) {
        log?.debug('onLaderaumGeaendert');
    }

    private updateBehaelter(vo: AuftragspositionVO) {
        log?.debug('updateBehaelter');

        if (!vo.behaelter) {
            vo.behaelter = [];

            if (vo.auftragsposition.Behaelter) {
                for (const behaelter of vo.auftragsposition.Behaelter) {
                    const b: BehaelterbewegungVO = {
                        aktion: behaelter.Aktion as any,
                        behaelterNr: behaelter.BehaelterNr,
                        name: 'Behälter',
                        isScan: behaelter.IsScan,
                        abstellortKey: behaelter.Abstellort,
                        zustand: behaelter.Zustand,
                        position: behaelter.Position
                        // aktiv: false
                    };

                    if (behaelter.IsScan) {
                        b.gescannteBehaelterNr = behaelter.BehaelterNr;
                    }

                    vo.behaelter.push(b);
                }
            }
        }

        const oldBehaelter = [...vo.behaelter];
        const neueBehaelter: BehaelterbewegungVO[] = [];

        const abstellortVerwenden = MyApp.current.behaelterAbstellorteVerwenden.getValue();

        if (vo.auftragsposition.BhAktion && vo.auftragsposition.Menge > 0) {
            const bhAktion = vo.auftragsposition.BhAktion.toLowerCase().trim();
            let anzahl = Math.ceil(vo.auftragsposition.Menge);

            if (anzahl > 100) {
                anzahl = 100;
            }

            switch (bhAktion) {
                case 'stellen':
                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Behälter' : 'Behälter';

                        neueBehaelter.push({
                            name,
                            aktion: 'stellen',
                            behaelterNr: '',
                            position: null
                        });
                    }
                    break;

                case 'tauschen':
                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Steller' : 'Steller';

                        neueBehaelter.push({
                            name,
                            aktion: 'stellen',
                            behaelterNr: '',
                            position: null
                        });
                    }

                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Abzieher' : 'Abzieher';

                        neueBehaelter.push({
                            name,
                            aktion: 'abziehen',
                            behaelterNr: '',
                            abstellortAktiv: abstellortVerwenden,
                            position: null
                        });
                    }
                    break;

                case 'abziehen':
                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Behälter' : 'Behälter';

                        neueBehaelter.push({
                            name,
                            aktion: 'abziehen',
                            behaelterNr: '',
                            abstellortAktiv: abstellortVerwenden,
                            position: null
                        });
                    }
                    break;

                case 'entleeren':
                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Behälter' : 'Behälter';

                        neueBehaelter.push({
                            name,
                            aktion: 'entleeren',
                            behaelterNr: '',
                            position: null
                        });
                    }
                    break;

                case 'umsetzen':
                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Behälter' : 'Behälter';

                        neueBehaelter.push({
                            name,
                            aktion: 'umsetzen',
                            behaelterNr: '',
                            position: null
                        });
                    }
                    break;

                case 'direktbeladung':
                case 'warten':
                    for (let i = 1; i <= anzahl; i++) {
                        const name = anzahl > 1 ? i + '. Behälter' : 'Behälter';

                        neueBehaelter.push({
                            name,
                            aktion: 'direktbeladung',
                            behaelterNr: '',
                            position: null
                        });
                    }
                    break;
            }

            // distinct
            const aktionen = neueBehaelter.map(p => p.aktion).filter((value, index, self) => self.indexOf(value) === index);

            const standardAbstellort = this.abstellortListe.find(p => p.IsStandardContainerAbstellort);

            // Übernehme bereits vorhandene Daten
            for (const aktion of aktionen) {
                const oldList = oldBehaelter.filter(p => p.aktion == aktion);
                const newList = neueBehaelter.filter(p => p.aktion == aktion);

                for (let i = 0; i < oldList.length; i++) {
                    if (i < newList.length) {
                        const old = oldList[i];
                        const newItem = newList[i];

                        if (!old.abstellortKey && standardAbstellort) {
                            old.abstellortKey = standardAbstellort.Key;
                        }

                        if (old.abstellortKey) {
                            newItem.abstellort = this.abstellortListe.find(p => p.Key === old.abstellortKey);
                        }

                        newItem.behaelterNr = old.behaelterNr;
                        newItem.abstellortKey = old.abstellortKey;
                        newItem.zustand = old.zustand;
                        newItem.position = old.position;
                        newItem.gescannteBehaelterNr = old.gescannteBehaelterNr;

                        if (old.behaelterNr) {
                            const uvvBehaelter = this.uvvService.getBehaelterByBehaelterNr(old.behaelterNr, old.isScan);

                            this.updateBehaelterManuelleNummer(newItem, uvvBehaelter);
                        }
                    }
                }
            }
        }

        vo.behaelter = neueBehaelter;

        this.detectChanges();
    }

    private detectChanges() {
        try {
            this.cdr.detectChanges();
        } catch (err) {
            // ignroe
        }
    }

    ngAfterViewInit() {
        if (AppConfig.current.einstellungen.FocusErstePosition === 'ja' && !this.istAuftragReadOnly) {
            setTimeout(() => {
                const input = document.querySelector('input.native-input') as HTMLInputElement;

                if (input) {
                    input.focus();
                    input.select();
                }
            }, 500);
        }
    }

    verarbeiteNfcEvent(event: NfcEvent) {
        log?.debug('verarbeiteNfcEvent');

        try {
            log?.debug('NFC seriennummer: ' + event.seriennummer);

            this.ngZone.run(() => {
                let barcode: string;

                if (MyApp.current.NfcPayloadVerwenden && event.payload) {
                    barcode = event.payload;
                } else {
                    barcode = event.seriennummer;
                }

                if (this.barcodeZielTyp === 'Behaelterbewegung' && this.barcodeZiel) {
                    const vo = this.barcodeZiel as BehaelterbewegungVO;
                    vo.behaelterNr = barcode.trim();
                    vo.gescannteBehaelterNr = barcode.trim();
                    vo.isScan = true;

                    // Position hier nur asynchron holen und in Behälterbewegung merken
                    this.systemService.getAktuelleGpsPosition('Behälter NFC').then(p => {
                        vo.position = p;
                        this.speichereBehaelterAenderung();
                    });

                    this.pruefeBehaelterNr(vo);

                } else if (this.barcodeZielTyp === 'Eigenschaft' && this.barcodeZiel) {
                    const vo = this.barcodeZiel as ReCoMobilEigenschaftEx;
                    vo.Wert = barcode.trim();
                }

                this.barcodeZielTyp = '';

                this.detectChanges();
            });

            if (this.nfcAlert) {
                this.nfcAlert.dismiss();
                this.nfcAlert = null;
            }
        } catch (err) {
            log.error('verarbeiteNfcEvent: ' + err, err);
        }
    }

    /**
     * Übernimtm die Daten aus dem Formular in den Auftrag (nur die, die nicht sowieso direkt geschrieben wurden)
     */
    aktualisiereAuftrag() {
        log?.debug('aktualisiereAuftrag: ' + this.auftrag.Key);

        const behaelterPruefung = MyApp.current.behaelterNummerPruefung.getValue();

        if (this.auftrag) {
            for (const positionVo of this.allePositionen) {
                positionVo.auftragsposition.Behaelter = [];
                positionVo.auftragsposition.MengeIst = positionVo.auftragsposition.Menge;

                if (positionVo.behaelter) {
                    for (const b of positionVo.behaelter) {
                        const behaelter: ReCoMobilBehaelterbewegung = {
                            Aktion: b.aktion,
                            BehaelterNr: b.behaelterNr,
                            Abstellort: b.abstellortKey,
                            Zustand: b.zustand,
                            Position: b.position,
                            IsScan: b.behaelterNr === b.gescannteBehaelterNr
                        };

                        if (b.abstellort) {
                            behaelter.Abstellort = b.abstellort.Key;
                        }

                        if (b.behaelterNrUngueltig && behaelterPruefung === 'fehler') {
                            // Ungültige Behälter-Nummer nicht übernehmen
                            behaelter.BehaelterNr = '';
                            behaelter.Position = null;
                        }

                        positionVo.auftragsposition.Behaelter.push(behaelter);
                    }
                }

                if (this.laderaumAuswahlAktiv) {
                    if (positionVo.auftragsposition.Laderaum) {
                        // Noch die Laderaum-Nummer aktualisieren.
                        const vo = this.laderaeume.find(p => p.key == positionVo.auftragsposition.Laderaum);

                        if (vo) {
                            positionVo.auftragsposition.LaderaumNummer = vo.nummer;
                        }
                    }
                }
            }
        }
    }

    /**
     * Überträgt die aktuellen Formulardaten (u.a. die Behälternummern) in den Auftrag und speichert diesen sofort ab.
     * Wird nach der Eingabe/dem Scan einer Behälternummer aufgerufen, damit diese - analog zu den Wiegungen -
     * nicht erst beim Verlassen der Seite persistiert wird und bei einem Absturz nicht verloren geht.
     */
    private async speichereBehaelterAenderung() {
        this.aktualisiereAuftrag();

        if (this.auftragService.istAktiverAuftrag(this.auftrag)) {
            await this.auftragService.speichereAuftrag(this.auftrag);
        }
    }

    /**
     * Runs when the page is about to be destroyed and have its elements removed.
     */
    async ngOnDestroy() {
        log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.systemService.unregisterNfcReceiver(this.nfcRegistrationId);

        log?.debug('ionViewWillLeave');

        this.aktualisiereAuftrag();

        if (this.auftragService.istAktiverAuftrag(this.auftrag)) {
            await this.auftragService.speichereAuftrag(this.auftrag);

            // this.auftragService.setzeAktivenAuftrag(null, 'lieferung details exit');
        }

        MyApp.current.klingelnBlockiert.next(false);

        this.auftragdetails.auftragspositionenGeaendert.next();
    }

    /**
     * Wird aufgerufen bevor eine Wizard-Seite verlassen wird.
     */
    onBeforePageLeave(): void {
        log?.debug('onBeforePageLeave');

        // Auftrag muss aktualisiert werden, damit die Validierung funktioniert
        this.aktualisiereAuftrag();
    }

    onReset() {
    }

    async ladeAbstellorte() {
        const adressen = await this.stammdatenService.getAdressen();
        this.abstellortListe = adressen.filter(p => p.IsContainerAbstellort);
    }

    async ladeArtikelListe() {
        const sub = this.stammdatenService.getAlleArtikel().subscribe(data => {
            this.artikelList = data;

            // log?.debug('artikelList', this.artikelList);

            this.artikellisteGeladen();

            // Sortieren nach angegebener Sortierung
            // this.artikelList.sort((a, b) => a.sortierung - b.sortierung);
        });

        this.subscriptions.push(sub);
    }

    artikellisteGeladen() {
        if (!this.auftrag) {
            return;
        }

        let geaendert = false;

        // Korrigiere fehlende Eigenschafts-Typen
        for (const position of this.auftrag.Positionen) {
            // Hier extra mit == prüfen. Kann Zahl oder String sein
            const artikel = this.artikelList.find(p => p.artikelKey as any == position.ArtikelKey);

            if (artikel) {
                geaendert = geaendert || this.auftragdetails.aktualisierePositionsEigenschaften(position, artikel);
            }
        }

        if (geaendert) {
            // updatePositionen() ruft updateAuftragsposition() für alle Positionen ohnehin auf
            this.updatePositionen();
        } else {
            // Sonderlogik (z.B. Totgeburt) erneut anwenden: aktualisierePositionsEigenschaften()
            // kann Regex / Sonderpruefung aus den Stammdaten zurückgeschrieben haben.
            for (const vo of this.allePositionen) {
                this.updateAuftragsposition(vo);
            }

            this.detectChanges();
        }
    }

    validiereMenge(vo: AuftragspositionVO) {
        vo.mengeUngueltig = false;

        if (typeof (vo.auftragsposition.Menge) === 'string' && vo.auftragsposition.Menge !== '') {
            vo.auftragsposition.Menge = Utils.parseFloat(vo.auftragsposition.Menge);
        }

        if (vo.auftragsposition.Menge === null || typeof (vo.auftragsposition.Menge) === 'undefined' || (vo.auftragsposition.Menge as any) === '') {
            vo.mengeUngueltig = true;
        }

        if (vo.auftragsposition.MengeOption === MengeOptionTyp.StandardOderNull) {
            if (vo.auftragsposition.Menge != vo.auftragsposition.StandardMenge && vo.auftragsposition.Menge !== 0 && vo.auftragsposition.StandardMenge) {
                vo.mengeUngueltig = true;
                log.warn(`Menge ungültig: ArtikelKey=${vo.auftragsposition.ArtikelKey}, Option=${vo.auftragsposition.MengeOption}, StandardMenge=${vo.auftragsposition.StandardMenge}, Menge=${vo.auftragsposition.Menge}`);
            }
        } else if (vo.auftragsposition.MengeOption === MengeOptionTyp.AenderbarGroesserNull) {
            if (vo.auftragsposition.Menge <= 0) {
                vo.mengeUngueltig = true;
                log.warn(`Menge ungültig: ArtikelKey=${vo.auftragsposition.ArtikelKey}, Option=${vo.auftragsposition.MengeOption}, Menge=${vo.auftragsposition.Menge}`);
            }
        } else {
            if (vo.auftragsposition.Menge === null || typeof (vo.auftragsposition.Menge) === 'undefined') {
                vo.mengeUngueltig = true;
            }
        }
    }

    validiereGewicht(vo: AuftragspositionVO) {
        vo.gewichtUngueltig = false;

        if (vo.auftragsposition.Menge && vo.auftragsposition.GewichtInKgAktiv && vo.auftragsposition.GewichtInKgPflicht) {
            if (!vo.auftragsposition.GewichtInKg) {
                vo.gewichtUngueltig = true;
            }
        }
    }

    artikelChanged(vo: AuftragspositionVO) {
        log?.debug('artikelChanged', vo);

        // tslint:disable-next-line:triple-equals
        const artikel = this.artikelList.find(p => p.artikelKey == vo.artikel.artikelKey);

        log?.info('artikel', vo.artikel);
        log?.info('artikelList', this.artikelList);
        log?.info('auftragsposition vo', vo);
        log?.info('artikel', artikel);

        if (artikel) {
            vo.auftragsposition.ArtikelKey = artikel.artikelKey as any;
            vo.auftragsposition.Bezeichnung = artikel.bezeichnung;
            vo.auftragsposition.Einheit = artikel.einheit;

            vo.auftragsposition.Eigenschaften = [];

            for (const p of artikel.eigenschaften) {
                vo.auftragsposition.Eigenschaften.push({
                    Bezeichnung: p.bezeichnung,
                    Typ: p.typ,
                    Wert: '',
                    Sortierung: p.sortierung
                });
            }

            AuftragHelper.sortiereEigenschaften(vo.auftragsposition.Eigenschaften);
        }

        log?.debug('artikelChanged after', vo);

        this.cdr.detectChanges();
    }

    abstellortChanged(b: BehaelterbewegungVO) {
        log?.debug('abstellortChanged', b);

        if (b.abstellort) {
            b.abstellortKey = b.abstellort.Key;
        }

        this.cdr.detectChanges();
    }

    async onArtikelAendern(vo: AuftragspositionVO) {
        if (this.auftragdetails.isLieferungAendernGesperrt) {
            this.auftragdetails.showAuftragSchreibgeschuetzt();
            return;
        }

        if (!vo.auftragsposition) {
            log.warn('vo.auftragsposition ist NULL');
            return;
        }

        if (!vo.isArtikelAenderbar) {
            return;
        }

        const modal = await this.modalController.create({
            component: AuftragArtikelAuswahlPage,
            componentProps: {
                'auftrag': this.auftrag
            }
        });

        log?.debug('AuftragArtikelAuswahlPage wird angezeigt...');
        await modal.present();

        const modalResult = await modal.onDidDismiss();

        log?.debug('AuftragArtikelAuswahlPage wurde geschlossen', modalResult);

        if (!modalResult) {
            // Abbruch
            return;
        }

        const artikel = modalResult.data.artikel as Artikel;
        const vertragsposition = modalResult.data.vertragsposition as Vertragsposition;

        if (artikel) {
            vo.artikel = artikel;

            if (!vo.auftragsposition.IstNeu && !vo.auftragsposition.ArtikelWurdeGeaendert) {
                if (vo.auftragsposition.ArtikelKey != artikel.artikelKey as any) {
                    vo.auftragsposition.ArtikelWurdeGeaendert = true;
                }
            }

            vo.auftragsposition.Bezeichnung = artikel.bezeichnung;
            vo.auftragsposition.Bezeichnung2 = artikel.Bezeichnung2;
            vo.auftragsposition.AuftragWiegungAktiv = artikel.AuftragWiegungAktiv;
            vo.auftragsposition.ArtikelKey = artikel.artikelKey as any;
            vo.auftragsposition.Einheit = artikel.einheit;
            // raus, damit bei einer Änderung die alten Eigenschaftswerte noch übernommen werden können (OFK)
            // vo.auftragsposition.Eigenschaften = []; //

            this.auftragdetails.aktualisierePositionsEigenschaften(vo.auftragsposition, artikel);

            this.updatePositionen();

            this.cdr.detectChanges();
        } else if (vertragsposition) {
            vo.artikel = null; // vertragsposition;
            vo.vertragsposition = vertragsposition;

            if (!vo.auftragsposition.IstNeu && !vo.auftragsposition.ArtikelWurdeGeaendert) {
                if (vo.auftragsposition.ArtikelKey != vertragsposition.ArtikelKey as any) {
                    vo.auftragsposition.ArtikelWurdeGeaendert = true;
                }
            }

            vo.auftragsposition.Bezeichnung = vertragsposition.Bezeichnung;
            vo.auftragsposition.ArtikelKey = vertragsposition.ArtikelKey as any;
            vo.auftragsposition.Eigenschaften = []; //

            this.auftragdetails.aktualisierePositionsEigenschaftenAusVertragsposition(vo.auftragsposition, vertragsposition);

            this.updatePositionen();

            this.cdr.detectChanges();
        }
    }

    async onPositionHinzufuegen() {
        const ok = await this.auftragdetails.onPositionHinzufuegen();

        if (!ok) {
            // Abbruch
            return;
        }

        this.updatePositionen();

        this.cdr.detectChanges();

        setTimeout(() => {
            if (this.content) {
                this.content.scrollToBottom(300);
            }
        }, 100);
    }

    async onPositionLoeschen(e: Event, vo: AuftragspositionVO) {
        const ok = await this.auftragdetails.loescheAuftragsposition(vo.auftragsposition);

        if (ok) {
            this.updatePositionen();
        }
    }

    async scanBehaelterBarcode(vo: AuftragspositionVO, b: BehaelterbewegungVO) {
        BarcodeAuthGuard.barcodeScanAktiv = true;

        try {
            let barcodeData = await MyApp.scanBarcode({ debugFallback: 'DEMO' });

            log?.debug(`scanBehaelterBarcode: ${barcodeData.text}`);

            if (barcodeData.text) {
                b.behaelterNr = barcodeData.text;
                b.gescannteBehaelterNr = barcodeData.text;
                b.isScan = true;

                // Position hier nur asynchron holen und in Behälterbewegung merken
                this.systemService.getAktuelleGpsPosition('Behälter Barcode').then(position => {
                    b.position = position;
                    this.speichereBehaelterAenderung();
                });

                if (this.auftragdetails) {
                    this.auftragdetails.starteAuftragWennErforderlich('onBehaelterNrLostFocus');
                }

                this.cdr.detectChanges();

                setTimeout(() => {
                    this.pruefeBehaelterNr(b);
                }, 150);
            }
        } catch (err) {
            UiHelper.showError(err);
        }

        setTimeout(() => BarcodeAuthGuard.barcodeScanAktiv = false, 500);
    }

    async scanEigenschaftNfc(vo: any, p: ReCoMobilEigenschaftEx) {
        log?.debug('scanEigenschaftNfc');

        BarcodeAuthGuard.barcodeScanAktiv = true;
        this.barcodeZiel = p;
        this.barcodeZielTyp = 'Eigenschaft';

        if (this.nfcAlert) {
            this.nfcAlert.dismiss();
            this.nfcAlert = null;
        }

        this.nfcAlert = await this.alertController.create({
            mode: 'ios',
            message: I18N.instant('NFCErkennungLaeuft'),
            buttons: [{
                text: I18N.instant('Abbrechen'),
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                }
            },
            ]
        });

        if (!MyApp.isCordovaAvailable()) {
            setTimeout(() => {
                this.nfcAlert.dismiss();
                p.Wert = 'DEMO12345';
            }, 2000);
        }

        await this.nfcAlert.present();

        await this.nfcAlert.onDidDismiss();

        if (this.auftragdetails) {
            this.auftragdetails.starteAuftragWennErforderlich('scanEigenschaftNfc');
        }

        setTimeout(() => BarcodeAuthGuard.barcodeScanAktiv = false, 500);
    }

    async scanBehaelterNfc(e: Event, vo: AuftragspositionVO, b: BehaelterbewegungVO) {
        ClickHelper.click(e, async () => {
            BarcodeAuthGuard.barcodeScanAktiv = true;

            this.barcodeZiel = b;
            this.barcodeZielAuftragsposition = vo;
            this.barcodeZielTyp = 'Behaelterbewegung';

            if (this.nfcAlert) {
                this.nfcAlert.dismiss();
                this.nfcAlert = null;
            }

            this.nfcAlert = await this.alertController.create({
                mode: 'ios',
                message: I18N.instant('NFCErkennungLaeuft'),
                buttons: [{
                    text: I18N.instant('Abbrechen'),
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                },
                ]
            });

            if (!MyApp.isCordovaAvailable()) {
                setTimeout(() => {
                    this.nfcAlert.dismiss();
                    b.behaelterNr = 'E00401005872eEB8';

                    this.pruefeBehaelterNr(b);
                }, 2000);
            }

            await this.nfcAlert.present();

            await this.nfcAlert.onDidDismiss();

            if (this.auftragdetails) {
                await this.auftragdetails.starteAuftragWennErforderlich('scanBehaelterNfc');
            }

            setTimeout(() => BarcodeAuthGuard.barcodeScanAktiv = false, 500);
        });
    }

    // async onBehaelterFocus(b: BehaelterbewegungVO) {
    //     log?.debug('onBehaelterFocus', b);

    //     if (this.nfcAktiv) {
    //         b.aktiv = true;
    //     }

    //     setTimeout(() => {
    //         this.isBarcodeFeld = true;
    //         this.barcodeZiel = b;
    //         this.barcodeZielTyp = 'Behaelterbewegung';

    //         this.detectChanges();
    //     }, 250);
    // }

    // onBehaelterLostFocus(b: BehaelterbewegungVO) {
    //     log?.debug('onBehaelterLostFocus', b);
    //     b.aktiv = false;

    //     setTimeout(() => {
    //         this.isBarcodeFeld = false;
    //         this.barcodeZiel = null;
    //         this.barcodeZielTyp = null;

    //         this.detectChanges();
    //     }, 150);

    //     setTimeout(() => {
    //         log?.info('document.activeElement', document.activeElement);
    //     }, 500);
    // }

    async onEigenschaftFocus(vo: AuftragspositionVO, p: Eigenschaft) {
        log?.debug('onEigenschaftFocus', { vo, p });

        setTimeout(() => {
            this.isBarcodeFeld = true;
            this.barcodeZiel = p;
            this.barcodeZielTyp = 'Behaelterbewegung';

            this.detectChanges();
        }, 250);
    }

    onEigenschaftLostFocus(vo: AuftragspositionVO, p: Eigenschaft) {
        log?.debug('onEigenschaftLostFocus', { vo, p });

        setTimeout(() => {
            this.isBarcodeFeld = false;
            this.barcodeZiel = null;
            this.barcodeZielTyp = null;

            if (p.Wert) {
                if (this.auftragdetails) {
                    this.auftragdetails.starteAuftragWennErforderlich('onEigenschaftLostFocus');
                }
            }

            this.detectChanges();
        }, 150);
    }

    // onEigenschaftDatumLostFocus(vo: AuftragspositionVO, b: BehaelterbewegungVO) {
    //     log?.debug('onEigenschaftDatumLostFocus', { vo, b });

    //     if (b.behaelterNr) {
    //         if (this.auftragdetails) {
    //             this.auftragdetails.starteAuftragWennErforderlich('onBehaelterNrLostFocus');
    //         }
    //     }
    // }

    onBehaelterNrLostFocus(vo: AuftragspositionVO, b: BehaelterbewegungVO) {
        log?.debug('onBehaelterNrLostFocus', { vo, b });

        if (b.behaelterNr) {
            if (this.auftragdetails) {
                this.auftragdetails.starteAuftragWennErforderlich('onBehaelterNrLostFocus');
            }
        }

        setTimeout(() => {
            this.pruefeBehaelterNr(b);

            if (b.behaelterNr) {
                if (b.changed) {
                    this.systemService.getAktuelleGpsPosition('Behälter manuell').then(position => {
                        b.position = position;
                        this.speichereBehaelterAenderung();
                    });
                } else {
                    this.speichereBehaelterAenderung();
                }
            } else {
                b.position = null;
                this.speichereBehaelterAenderung();
            }

            b.changed = false;
        }, 150);
    }

    onBehaelterNrChanged(vo: AuftragspositionVO, b: BehaelterbewegungVO) {
        // hier nichts machen. wird mit jedem tastendruck ausgelöst
        b.changed = true;
    }

    async pruefeBehaelterNr(b: BehaelterbewegungVO): Promise<void> {
        if (StringHelper.isBlank(b.behaelterNr)) {
            b.manuelleNummer = null;
            return;
        }

        const uvvBehaelter = this.uvvService.getBehaelterByBehaelterNr(b.behaelterNr, b.isScan);

        const fahrer = MyApp.current.fahrer.getValue();

        log?.debug('pruefeBehaelterNr', {
            uvvBehaelter,
            fahrer
        });

        if (uvvBehaelter) {
            if (MyApp.current.uvvBerechtigt.getValue()) {
                if (UvvHelper.istFaelligFuerPruefung(uvvBehaelter)) {
                    this.uvvPruefungModal = await this.modalController.create({
                        component: UvvPruefungModalPage,
                        componentProps: {
                            'gegenstand': uvvBehaelter
                        }
                    });

                    log?.debug('uvvPruefungModal wird angezeigt...');
                    await this.uvvPruefungModal.present();

                    await this.uvvPruefungModal.onDidDismiss();
                    log?.debug('uvvPruefungModal wurde geschlossen');
                    this.uvvPruefungModal = null;

                    this.updateBehaelterManuelleNummer(b, uvvBehaelter);

                    return;
                }
            }

            // Für nicht UVV-Berechtigte Fahrer muss geprüft werden ob die UVV abgelaufen ist
            if (UvvHelper.istUvvUeberfaellig(uvvBehaelter)) {
                const abgelaufeneUvvPruefung = AppConfig.current.einstellungen.BehaelterNummerAbgelaufeneUvvPruefung;

                if (abgelaufeneUvvPruefung === 'fehler' || abgelaufeneUvvPruefung === 'warnung') {
                    const ablaufDatum = moment(uvvBehaelter.naechstePruefung);

                    await UiHelper.showAlert('Die UVV-Prüfung für den Behälter ' + b.behaelterNr + ' ist abgelaufen: ' + ablaufDatum.format('DD.MM.YYYY'), null, true);

                    // Hier soll zusätzlich eine Mailbenachrichtigung an den Disponenten versendet werden.
                    if (AppConfig.current.einstellungen.BehaelterNummerAbgelaufeneUvvPruefungMailbenachrichtung === "ja") {
                        const gpsPosiion = await this.systemService.getAktuelleGpsPosition('UVVHinwisMeldung', 60);

                        const textdatei: Textdatei = {
                            typ: TextdateiTyp.UvvHinweisMeldung,
                            datum: Utils.nowIsoDateString(),
                            geraeteNummer: AppConfig.current.geraeteNummer,
                            UvvHinweisMeldung: {
                                Typ: 'UvvAbgelaufen',
                                UvvPruefGegenstand: uvvBehaelter,
                                Personal: MyApp.getFahrerRef(),
                                Fahrzeug: MyApp.getFahrzeugRef(),
                                Datum: Utils.nowIsoDateString(),
                                Guid: Utils.uuid(),
                                Longitude: gpsPosiion?.Longitude,
                                Latitude: gpsPosiion?.Latitude,
                            },
                        };

                        await this.systemService.sendeTextdatei(textdatei, false);
                    }

                    if (abgelaufeneUvvPruefung === 'fehler' && b.aktion == 'stellen') {
                        // Behälter-Nummer darf nicht übernommen werden
                        b.behaelterNr = '';
                        b.manuelleNummer = '';
                    }
                }
            }

            if (AppConfig.current.einstellungen.BehaelterNummerBeschaedigungPruefung) {
                log?.debug('BehaelterNummerBeschaedigungPruefung', uvvBehaelter);

                if (uvvBehaelter.zustand === 'beschaedigt') {
                    if (b.aktion == 'stellen') {
                        await UiHelper.showAlert('Behälter ist beschädigt und darf nicht verwendet werden', 'Beschädigung', true);
                    } else {
                        await UiHelper.showAlert('Behälter ist beschädigt', 'Achtung', true);
                    }

                    if (AppConfig.current.einstellungen.BehaelterNummerBeschaedigungPruefung === 'fehler' && b.aktion == 'stellen') {
                        // Behälter-Nummer darf nicht übernommen werden
                        b.behaelterNr = '';
                        b.manuelleNummer = '';
                    }
                }
            }
        }

        if (!uvvBehaelter) {
            const behaelterPruefung = MyApp.current.behaelterNummerPruefung.getValue();

            if (behaelterPruefung === 'fehler') {
                UiHelper.showAlert('Ungültige Behälter-Nummer: ' + b.behaelterNr);
            } else if (behaelterPruefung === 'warnung') {
                UiHelper.showAlert('Behälter-Nummer nicht gefunden: ' + b.behaelterNr);
            }
        }

        this.updateBehaelterManuelleNummer(b, uvvBehaelter);
    }

    private updateBehaelterManuelleNummer(b: BehaelterbewegungVO, uvvBehaelter: UvvPruefGegenstand) {
        if (uvvBehaelter) {
            b.behaelterNrUngueltig = false;
            b.manuelleNummer = '';

            if (b.behaelterNr) {
                if (uvvBehaelter.manuelleNummer) {
                    b.manuelleNummer += uvvBehaelter.manuelleNummer;
                }

                if (uvvBehaelter.bezeichnung) {
                    b.manuelleNummer += ' - ' + uvvBehaelter.bezeichnung;
                }

                if (b.manuelleNummer == b.behaelterNr) {
                    b.manuelleNummer = '';
                }
            }
        } else {
            b.behaelterNrUngueltig = true;
            b.manuelleNummer = null;
        }
    }

    istPlusMinusButtonsAnzeigen(vo: AuftragspositionVO) {
        if (this.auftragdetails.isLieferungAendernGesperrt) {
            return false;
        }

        if (!this.plusMinusButtonAnzeigen) {
            return false;
        }

        // if (!this.plusMinusButtons) {
        //     // Die Buttons sollen generell nicht angezeigt werden
        //     return false;
        // }

        const mengeOption = this.getMengeOption(vo);

        if (mengeOption === MengeOptionTyp.NichtAenderbar) {
            return false;
        }

        // TODO hier eventuell einbauen, das minus Button nicht mehr angezeigt wird bei 1

        // let einheit = vo.auftragsposition.Einheit;

        // if (einheit) {
        //     einheit = einheit.toLowerCase();

        //     if (einheit == "t" || einheit == 'to' || einheit == 'tonnen') {
        //         // Tonnen müssen genau erfasst werden
        //         return false;
        //     }
        // }

        return true;
    }

    erhoeheMenge(p: AuftragspositionVO) {
        log?.debug('erhoeheMenge');

        if (this.auftragdetails.isLieferungAendernGesperrt) {
            this.auftragdetails.showAuftragSchreibgeschuetzt();
            return;
        }

        const mengeOption = this.getMengeOption(p);

        if (p.auftragsposition) {
            p.auftragsposition.Menge = Utils.parseFloat(p.auftragsposition.Menge);
        }

        switch (mengeOption) {
            case MengeOptionTyp.AenderbarGroesserNull:
            case MengeOptionTyp.Aenderbar:
                if (!p.auftragsposition.Menge) {
                    p.auftragsposition.Menge = 0;
                }

                p.auftragsposition.Menge = Math.round(p.auftragsposition.Menge + 1);

                break;
            case MengeOptionTyp.StandardOderNull:
                const standardMenge = this.auftragService.getStandardMenge(p);

                if (p.auftragsposition.Menge == standardMenge) {
                    UiHelper.showAlert('Menge kann nicht erhöht werden. Bitte zusätzliche Auftragsposition hinzufügen.');
                } else {
                    p.auftragsposition.Menge = standardMenge;
                }
                break;
            case MengeOptionTyp.NichtAenderbar:
                return;
        }

        this.onMengeGeaendert(p);
    }

    reduziereMenge(p: AuftragspositionVO) {
        log?.debug('reduziereMenge');

        if (this.auftragdetails.isLieferungAendernGesperrt) {
            this.auftragdetails.showAuftragSchreibgeschuetzt();
            return;
        }

        const mengeOption = this.getMengeOption(p);

        if (p.auftragsposition) {
            p.auftragsposition.Menge = Utils.parseFloat(p.auftragsposition.Menge);
        }

        switch (mengeOption) {
            case MengeOptionTyp.Aenderbar:
                if (p.auftragsposition.Menge >= 1) {
                    p.auftragsposition.Menge = Math.round(p.auftragsposition.Menge - 1);
                } else {
                    p.auftragsposition.Menge = 0;
                }

                break;
            case MengeOptionTyp.AenderbarGroesserNull:
                if (p.auftragsposition.Menge >= 2) {
                    p.auftragsposition.Menge = Math.round(p.auftragsposition.Menge - 1);
                } else {
                    // nicht erlauben
                }

                break;
            case MengeOptionTyp.StandardOderNull:
                p.auftragsposition.Menge = 0;
                break;
            case MengeOptionTyp.NichtAenderbar:
                return;
        }

        this.onMengeGeaendert(p);
    }

    getMengeOption(p: AuftragspositionVO): MengeOptionTyp {
        let option: MengeOptionTyp;

        if (p.MengeOption === null || typeof (p.MengeOption) === 'undefined') {
            const artikel = this.stammdatenService.getAlleArtikel().getValue().find(x => x.artikelKey as any == p.auftragsposition.ArtikelKey);

            if (artikel) {
                option = artikel.MengeOption;
            }
        } else {
            option = p.MengeOption;
        }

        if (!option) {
            option = MengeOptionTyp.Aenderbar;
        }

        return option;
    }

    /**
     * Die Wiegungen haben sich geändert.
     */
    onWiegungChanged(vo: AuftragspositionVO) {
        if (vo.auftragsposition.Wiegungen2) {
            if (vo.auftragsposition.NettoGewicht) {
                // Beide Wiegungen erfolgreich
                this.berechneMengeAusNettoGewicht(vo);
            }
        }
    }

    berechneMengeAusNettoGewicht(vo: AuftragspositionVO) {
        const nettoGewicht = vo.auftragsposition.NettoGewicht;

        vo.auftragsposition.GewichtInKg = nettoGewicht;

        let einheit = vo.auftragsposition.Einheit;

        if (einheit) {
            einheit = einheit.trim().toLowerCase();

            if (einheit == 'kg') {
                vo.auftragsposition.Menge = nettoGewicht;
            } else if (einheit == 'to' || einheit == 't') {
                vo.auftragsposition.Menge = nettoGewicht / 1000;
            }
        }

        this.cdr.detectChanges();
    }

    onWiegungenZuordnen(vo: AuftragspositionVO) {
        if (AppConfig.current.einstellungen.WaagenTyp === 'bosche') {
            this.onWiegungenZuordnenBoscheAblauf(vo);

            return;
        }

        const wiegedatenListe = this.waageService.wiegedaten.getValue();

        if (wiegedatenListe.length == 0) {
            UiHelper.showAlert('Keine Wiegungen vorhanden', 'Fehler');
            return;
        }

        if (!vo.auftragsposition.Wiegungen) {
            vo.auftragsposition.Wiegungen = [];
        }

        if (wiegedatenListe.length == 1) {
            vo.auftragsposition.Wiegungen.push(wiegedatenListe[0]);
            wiegedatenListe.splice(0, 1);
            this.waageService.setzeWiegedatenListe(wiegedatenListe);

            this.berechneMengeAusWiegungen(vo);
        } else {
            this.wiegungAuswahlAuftragsposition = vo;
            this.wiegedatenListe = wiegedatenListe;
            this.cdr.detectChanges();

            setTimeout(() => {
                this.wiegungenSelect.open();
            });
        }
    }

    async onWiegen(vo: AuftragspositionVO) {
        // Zeige einen Popup 
        await this.auftragdetails.auftragspositionWiegen(vo.auftragsposition)

        this.berechneMengeAusWiegungen(vo);
    }

    /** 
     * Energor / Bosche-Ablauf
    */
    async onWiegungenZuordnenBoscheAblauf(vo: AuftragspositionVO) {
        try {
            log?.info('onWiegungenZuordnenBoscheAblauf: ' + this.auftragdetails?.auftrag?.Auftragsnummer);

            const boscheWaage = this.waageService.getAktiveWaage();

            if (!boscheWaage) {
                UiHelper.showAlert('Keine aktive Waage gefunden', 'Fehler');
                return;
            }

            if (boscheWaage.getTyp() !== 'bosche') {
                UiHelper.showAlert('Die aktive Waage ist keine Bosche Waage', 'Fehler');
                return;
            }

            // Lese die letzte bekannte Alibi-Nummer von der App
            let letzteBekannteAlibiNr = await this.waageService.getLetzteGeleseneAlibiNr();

            MyApp.loading(true);

            let wiegedatenListe: Wiegedaten[] = this.waageService.wiegedaten.getValue();

            if (!wiegedatenListe) {
                // Sollte eigentlich nie eintreten
                wiegedatenListe = [];
            }

            // Lese die letzte Alibi-Nummer von der Waage
            const waageLetzteAlibiNr = await this.waageService.leseLetzteAlibiNummer();

            if (waageLetzteAlibiNr == letzteBekannteAlibiNr && !wiegedatenListe.length) {
                // Keine neuen Wiegungen vorhanden
                MyApp.loading(false);
                UiHelper.showAlert('Keine Wiegungen vorhanden', 'Fehler');
                return;
            }

            if (letzteBekannteAlibiNr > waageLetzteAlibiNr) {
                // Die letzte Alibi-Nummer ist größer als die von der Waage. Das kann passieren, wenn die die gekoppelte Waage geändert wird
                // oder wenn der Alibispeicher der Waage zurückgesetzt wurde.
                // In diesem Fall wird die letzte Alibi-Nummer auf 0 gesetzt, damit alle Wiegungen erneut gelesen werden.
                letzteBekannteAlibiNr = 0;
            }

            // Hole die neuen Wiegungen von der Waage
            // Maximal 50 Wiegungen werden gelesen
            let startNr = letzteBekannteAlibiNr + 1;

            startNr = Math.max(startNr, waageLetzteAlibiNr - 50);

            for (let nr = startNr; nr <= waageLetzteAlibiNr; nr++) {
                if (wiegedatenListe.find(w => w.Wiegenummer === nr)) {
                    log.warn(`Wiegedaten mit AlibiNr. ${nr} bereits bekannt. Wird übersprungen.`);
                    continue;
                }

                const wiegedaten = await boscheWaage.leseAlibieintrag(nr);

                if (wiegedaten) {
                    wiegedatenListe.push(wiegedaten);
                }
            }

            // Bei Energor sollen fehlerhafte Wiegedaten ignoriert werden. Das sind alle Wiegungen unter ca. 8 kg.
            const mindestGewicht = Utils.parseFloat(AppConfig.current.einstellungen.WaageMindestgewicht);

            if (mindestGewicht > -99999) {
                wiegedatenListe = wiegedatenListe.filter(p => p.Netto > mindestGewicht);
            }

            MyApp.loading(false);

            if (!wiegedatenListe.length) {
                UiHelper.showAlert('Keine Wiegungen vorhanden', 'Fehler');
                return;
            }

            // TODO: Tara aus dem Artikel vom Netto-Gewicht abziehen.
            // TODO: Tara muss noch mitgewschickt werden
            // vo.auftragsposition..

            if (!vo.auftragsposition.Wiegungen) {
                vo.auftragsposition.Wiegungen = [];
            }

            // Bei Energor sollen immer alle Wiegungen automatisch zugeordnet werden.
            // Eventuell falsche Wiegungen müssen dann von Hand entfernt werden. Das geht schneller, als erst die Wiegungen auswählen zu müssen.
            for (const wiegedaten of wiegedatenListe) {
                vo.auftragsposition.Wiegungen.push(wiegedaten);
            }

            // Sortiere die Liste der Wiegungen nach der Wiegenummer
            vo.auftragsposition.Wiegungen.sort((a, b) => a.Wiegenummer - b.Wiegenummer);

            // Entferne die Wiegedaten aus der Liste der nicht zugeordneten Wiegungen
            await this.waageService.setzeWiegedatenListe([]);

            // Merke die letzte Alibi-Nummer, damit sie beim nächsten Mal nicht erneut gelesen wird
            await this.waageService.speichereLetzteGeleseneAlibiNr(waageLetzteAlibiNr);

            this.berechneMengeAusWiegungen(vo);

            // TODO: Bei Abschluss des Auftrags prüfen, ob die Menge (Anzahl) mit der Anzahl der Wiegungen übereinstimmt.
            // Wenn die Anzahl nicht stimmt, dann soll bei Energor der Auftragsabschluss nicht möglich sein.
            // Es muss also möglich sein zu konfigurieren ob Warnung oder Fehler.

            // if (wiegedatenListe.length == 1) {
            //     // Genau eine Wiegung vorhanden. Kann direkt zugeordnet werden
            //     vo.auftragsposition.Wiegungen.push(wiegedatenListe[0]);

            //     this.waageService.setzeWiegedatenListe([]);

            //     // Merke die letzte Alibi-Nummer, damit sie beim nächsten Mal nicht erneut gelesen wird
            //     await this.waageService.speichereLetzteGeleseneAlibiNr(waageLetzteAlibiNr);

            //     this.berechneMengeAusWiegungen(vo);
            // } else {
            //     // Auswahl anzeigen
            //     this.wiegungAuswahlAuftragsposition = vo;
            //     this.wiegedatenListe = wiegedatenListe;

            //     Utils.sortByProperty(this.wiegedatenListe, p => p.Wiegenummer);

            //     this.cdr.detectChanges();

            //     // Die Wiegungen müssen auch im WaageService gespeichert werden, damit sie später erneut gelesen werden können.
            //     // Sie werden insbesondere bei der Auswahl der Wiegungen benötigt, also im onWiegungSelected()-Event.
            //     // Außerdem ist es gut, wenn bei Auftrag-Ende geprüft werden kann, ob alle Wiegungen zugeordnet wurden.
            //     this.waageService.setzeWiegedatenListe(wiegedatenListe);

            //     // Merke die letzte Alibi-Nummer, damit sie beim nächsten Mal nicht erneut gelesen wird
            //     await this.waageService.speichereLetzteGeleseneAlibiNr(waageLetzteAlibiNr);

            //     setTimeout(() => {
            //         this.wiegungenSelect.open();
            //     });
            // }
        } catch (err) {
            UiHelper.showError(err);
        } finally {
            const verbindungsmodus = AppConfig.current.einstellungen?.WaageVerbindungsModus;

            if (verbindungsmodus === 'nur-bei-bedarf') {
                // Verbindung direkt wieder trennen.
                this.waageService.disconnect();
            }

            MyApp.loading(false);
        }
    }

    onWiegungSelected(e: Event) {
        log?.debug('onWiegungSelected', e);

        try {
            const event = e as CustomEvent;

            const vo = this.wiegungAuswahlAuftragsposition;

            if (!vo.auftragsposition.Wiegungen) {
                vo.auftragsposition.Wiegungen = [];
            }

            const wiegedatenListe = this.waageService.wiegedaten.getValue();
            const ausgewaehlteWiegungen = event.detail.value as Wiegedaten[];

            if (ausgewaehlteWiegungen?.length) {
                for (const w of ausgewaehlteWiegungen) {
                    const idx = wiegedatenListe.indexOf(w);

                    if (idx >= 0) {
                        // Entferne Eintrag aus den verfügbaren Wiegungen
                        wiegedatenListe.splice(idx, 1);

                        // Und zur Auftragsposition hinzufügen
                        vo.auftragsposition.Wiegungen.push(w);
                    }
                }

                this.waageService.setzeWiegedatenListe(wiegedatenListe);

                this.berechneMengeAusWiegungen(vo);
            }
        } catch (err) {
            UiHelper.showError(err);
        }

        this.wiegungAuswahlAuftragsposition = null;

        this.cdr.detectChanges();
    }

    onWiegungEntfernen(vo: AuftragspositionVO, wiegung: Wiegedaten) {
        log?.info('onWiegungEntfernen: ', { vo, wiegung });

        if (!vo.auftragsposition.Wiegungen) {
            vo.auftragsposition.Wiegungen = [];
        }

        const idx = vo.auftragsposition.Wiegungen.indexOf(wiegung);

        if (idx >= 0) {
            // Wiegung aus Auftragsposition entfernen
            vo.auftragsposition.Wiegungen.splice(idx, 1);

            // Wiegung zu den bekannten Wiegungen hinzufügen
            const wiegedatenListe = this.waageService.wiegedaten.getValue();
            wiegedatenListe.push(wiegung);
            this.waageService.setzeWiegedatenListe(wiegedatenListe);

            this.berechneMengeAusWiegungen(vo);
        }
    }

    berechneMengeAusWiegungen(vo: AuftragspositionVO) {
        this.auftragdetails.berechneMengeAusWiegungen(vo.auftragsposition);

        this.cdr.detectChanges();
    }

    async onSuchen() {
        log?.debug('onSuchen');
        this.searchbarSichtbar.next(true);

        this.cdr.detectChanges();

        await delay(200);

        try {
            this.searchbar.setFocus();
        } catch (err) {
            log.error('setTimeout onSuchen: ' + Utils.getErrorMessage(err), err);
        }
    }

    onSearchChanged() {
        log?.debug('onSearchChanged');

        this.filterSichtbareAuftragspositionen();

        // this.detectChanges('onSearchChanged');
    }

    filterSichtbareAuftragspositionen() {
        log?.debug('filterSichtbareAuftragspositionen');

        let liste: AuftragspositionVO[];

        if (this.auftragsposition) {
            // Es soll nur die eine Auftragsposition angezeigt werden. Alle Filterkriterien werden ignoriert.
            this.sichtbarePositionen = this.allePositionen.filter(p => p.auftragsposition === this.auftragsposition);
            return;
        }

        if (this.suchtext && this.suchtext.trim()) {
            liste = [];

            const parts: string[] = this.suchtext.toLowerCase().trim().split(' ');

            for (const vo of this.allePositionen) {
                let isMatch = true;

                for (const str of parts) {
                    if (!vo.suchtext.includes(str)) {
                        isMatch = false;
                        break;
                    }
                }

                if (isMatch) {
                    liste.push(vo);
                }
            }
        } else {
            liste = this.allePositionen;
        }

        this.anzahlPositionAusgeblendet = 0;
        this.anzahlLeerePositionenWerdenAngezeigt = 0;

        if (this.isLeerePositionenAusblenden) {
            // Leere Positionen (Menge = 0) sollen nicht angezeigt werden, außer der Benutzer will sie explizit anzeigen
            let alteListe = [...liste];
            let neueListe = liste.filter(p => p.auftragsposition.MengeSoll || p.auftragsposition.Menge || p.auftragsposition.IstNeu);

            if (this.isLeerePositionAnzeigen) {
                this.anzahlLeerePositionenWerdenAngezeigt = alteListe.length - neueListe.length;
            } else {
                this.anzahlPositionAusgeblendet = alteListe.length - neueListe.length;
                liste = neueListe;
            }
        }

        log?.debug('filterSichtbareAuftragspositionen. anzahl=' + liste.length);

        this.sichtbarePositionen = liste;
    }

    onUpperCaseEigenschaftChange(eigenschaft: Eigenschaft) {
        if (eigenschaft && typeof (eigenschaft.Wert) === 'string') {
            eigenschaft.Wert = eigenschaft.Wert.toUpperCase();
        }
    }

    getSollMengeText(vo: AuftragspositionVO) {
        if (this.sollMengeAnzeigen && vo.auftragsposition) {
            if (vo.auftragsposition.MengeSoll) {
                return '(SOLL: ' + vo.auftragsposition.MengeSoll + ')';
            }
        }

        return '';
    }

    onPositionDrucken(vo: AuftragspositionVO) {
        log?.debug('onPositionDrucken', vo);

        this.auftragdetails.druckenAuftragsposition(vo.auftragsposition, false);
    }

    onSeriennummernBearbeiten(vo: AuftragspositionVO) {
        log?.debug('onSeriennummernBearbeiten', vo);

        this.auftragdetails.seriennummernBearbeiten(vo.auftragsposition);
    }

    onAllePositionenAnzeigen() {
        log?.info('onAllePositionenAnzeigen');

        this.isLeerePositionAnzeigen = true;
        this.filterSichtbareAuftragspositionen();

        this.cdr.detectChanges();
    }

    onLeerePositionenAusblenden() {
        log?.info('onLeerePositionenAusblenden');

        this.isLeerePositionAnzeigen = false;
        this.filterSichtbareAuftragspositionen();

        this.cdr.detectChanges();
    }

    onPositionEigenschaftValueChanged(vo: AuftragspositionVO, eigenschaft: ReCoMobilEigenschaftEx, e: any) {
        log?.debug('onPositionEigenschaftValueChanged', { vo, eigenschaft, e });

        const geaendert = this.updateAuftragsposition(vo);

        if (geaendert) {
            // Liste der Eigenschaften muss aktualisiert werden für Angular-Change-Detection
            vo.auftragsposition.Eigenschaften = [...vo.auftragsposition.Eigenschaften];

            this.cdr.detectChanges();
        }
    }

    /**
     * Aktualisiert die Regex und Sonderprüfung der Eigenschaften in Abhängigkeit von anderen gesetzten Eigenschaften.
     * Wird z.B. bei OFK für die Totgeburt-Eigenschaft verwendet.
     * Dann soll die Ohrmarke und das Geburtsdatum kein Pflichtfeld mehr sein.
     */
    updateAuftragsposition(vo: AuftragspositionVO): boolean {
        // NEUER CODE 
        if (!vo.auftragsposition?.Eigenschaften?.length) {
        return;
        }

        const totgeburtEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung === 'Totgeburt');
        const ohrmarkeEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung === 'Ohrmarke');
        const ohrmarkeFehltEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Ohrmarke fehlt'));
        const equidenpassEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Equidenpass'));
        const geburtsdatumEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Geburtsdatum'));
        const rinderpassEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung === 'Rinderpass');
        const rinderpassFehltEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Rinderpass fehlt'));
        const untersuchungOhrmarkeEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Ohrmarke ROT'));
        const amtlicheUntersuchungEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Amtliche Untersuchung'));
        // FIX #1: TBA-Ohrmarke separat ermitteln – sie soll IMMER Pflichtfeld bleiben
        const tbaOhrmarkeEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('TBA-Ohrmarke'));

        let geaendert = false;

        // Zuerst alles sichtbar machen (zurücksetzen)
        for (const e of vo.auftragsposition.Eigenschaften) {
            e.isAusgeblendet = false;
        }

        // FIX #5: Ohrmarke ROT (Unters. Ohrmarke) Sichtbarkeit/Pflicht steuern,
        // UNABHÄNGIG von Totgeburt/Equidenpass/etc.
        // Sie wird nur angezeigt und ist nur Pflicht, wenn "Amtliche Untersuchung" = JA.
        if (untersuchungOhrmarkeEigenschaft) {
            if (amtlicheUntersuchungEigenschaft && Utils.isTrue(amtlicheUntersuchungEigenschaft.Wert)) {
                // Sichtbar lassen, Regex/Sonderpruefung aus oldWerten wiederherstellen
                untersuchungOhrmarkeEigenschaft.isAusgeblendet = false;
                if (untersuchungOhrmarkeEigenschaft.oldRegex) {
                    untersuchungOhrmarkeEigenschaft.Regex = untersuchungOhrmarkeEigenschaft.oldRegex;
                }
                if (untersuchungOhrmarkeEigenschaft.oldSonderpruefung) {
                    untersuchungOhrmarkeEigenschaft.Sonderpruefung = untersuchungOhrmarkeEigenschaft.oldSonderpruefung;
                }
            } else {
                // Ausblenden und Pflicht entfernen
                untersuchungOhrmarkeEigenschaft.isAusgeblendet = true;
                if (!untersuchungOhrmarkeEigenschaft.oldRegex && untersuchungOhrmarkeEigenschaft.Regex) {
                    untersuchungOhrmarkeEigenschaft.oldRegex = untersuchungOhrmarkeEigenschaft.Regex;
                }
                if (!untersuchungOhrmarkeEigenschaft.oldSonderpruefung && untersuchungOhrmarkeEigenschaft.Sonderpruefung) {
                    untersuchungOhrmarkeEigenschaft.oldSonderpruefung = untersuchungOhrmarkeEigenschaft.Sonderpruefung;
                }
                untersuchungOhrmarkeEigenschaft.Regex = null;
                untersuchungOhrmarkeEigenschaft.Sonderpruefung = null;
                geaendert = true;
            }
        }

        // FIX #3/#4: Nur auf Totgeburt/Equidenpass/Rinderpass/OhrmarkeFehlt reagieren –
        // untersuchungOhrmarkeEigenschaft gehört NICHT in diese Bedingung
        if (totgeburtEigenschaft || equidenpassEigenschaft || rinderpassEigenschaft || ohrmarkeFehltEigenschaft) {
            const pflichtAufheben =
                Utils.isTrue(totgeburtEigenschaft?.Wert) ||
                Utils.isTrue(equidenpassEigenschaft?.Wert) ||
                Utils.isTrue(rinderpassEigenschaft?.Wert) ||
                Utils.isTrue(ohrmarkeFehltEigenschaft?.Wert);

            if (pflichtAufheben) {
                for (const eigenschaft of vo.auftragsposition.Eigenschaften) {
                    // FIX #1: TBA-Ohrmarke NIEMALS die Pflicht entfernen
                    if (tbaOhrmarkeEigenschaft && eigenschaft === tbaOhrmarkeEigenschaft) {
                        continue;
                    }

                    // FIX #5: Ohrmarke ROT wird separat gesteuert (siehe oben), hier überspringen
                    if (untersuchungOhrmarkeEigenschaft && eigenschaft === untersuchungOhrmarkeEigenschaft) {
                        continue;
                    }

                    // Merke die alten Werte für spätere Wiederherstellung
                    if (!eigenschaft.oldRegex) {
                        eigenschaft.oldRegex = eigenschaft.Regex;
                    }
                    if (!eigenschaft.oldSonderpruefung) {
                        eigenschaft.oldSonderpruefung = eigenschaft.Sonderpruefung;
                    }

                    if (eigenschaft.Regex) {
                        eigenschaft.Regex = null;
                        geaendert = true;
                    }
                    if (eigenschaft.Sonderpruefung) {
                        eigenschaft.Sonderpruefung = null;
                        geaendert = true;
                    }
                }

                // FIX #3: Ohrmarke und Geburtsdatum nur ausblenden, wenn Totgeburt aktiv
                if (totgeburtEigenschaft && geburtsdatumEigenschaft && Utils.isTrue(totgeburtEigenschaft.Wert)) {
                    geburtsdatumEigenschaft.isAusgeblendet = true;
                }
                if (totgeburtEigenschaft && ohrmarkeEigenschaft && Utils.isTrue(totgeburtEigenschaft.Wert)) {
                    ohrmarkeEigenschaft.isAusgeblendet = true;
                }
                // Bei einer Totgeburt sind "Ohrmarke fehlt" und "Rinderpass fehlt" gegenstandslos -> ebenfalls ausblenden
                if (totgeburtEigenschaft && ohrmarkeFehltEigenschaft && Utils.isTrue(totgeburtEigenschaft.Wert)) {
                    ohrmarkeFehltEigenschaft.isAusgeblendet = true;
                }
                if (totgeburtEigenschaft && rinderpassFehltEigenschaft && Utils.isTrue(totgeburtEigenschaft.Wert)) {
                    rinderpassFehltEigenschaft.isAusgeblendet = true;
                }

            } else {
                // Pflicht wiederherstellen, wenn alle Flags deaktiviert
                for (const eigenschaft of vo.auftragsposition.Eigenschaften) {
                    // FIX #5: Ohrmarke ROT wird separat gesteuert, hier überspringen
                    if (untersuchungOhrmarkeEigenschaft && eigenschaft === untersuchungOhrmarkeEigenschaft) {
                        continue;
                    }

                    if (eigenschaft.oldRegex && eigenschaft.oldRegex !== eigenschaft.Regex) {
                        eigenschaft.Regex = eigenschaft.oldRegex;
                        geaendert = true;
                    }
                    if (eigenschaft.oldSonderpruefung && eigenschaft.oldSonderpruefung !== eigenschaft.Sonderpruefung) {
                        eigenschaft.Sonderpruefung = eigenschaft.oldSonderpruefung;
                        geaendert = true;
                    }
                }
            }
        }

        return geaendert;

        // if (!vo.auftragsposition?.Eigenschaften?.length) {
        //     return;
        // }

        // const totgeburtEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung === 'Totgeburt');
        // const ohrmarkeEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung === 'Ohrmarke');
        // const ohrmarkeFehltEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Ohrmarke fehlt'));
        // const equidenpassEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Equidenpass'));
        // const geburtsdatumEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Geburtsdatum'));
        // const rinderpassEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung === 'Rinderpass');
        // // const amtlicheUntersuchungEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('TBA-Ohrmarke'));
        // const untersuchungOhrmarkeEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Ohrmarke ROT'));
        // const amtlicheUntersuchungEigenschaft = vo.auftragsposition.Eigenschaften.find(e => e.Bezeichnung.includes('Amtliche Untersuchung'));

        // let geaendert = false;

        // for (const e of vo.auftragsposition.Eigenschaften) {
        //     // Zuerst alles sichtbar machen (zurücksetzen)
        //     e.isAusgeblendet = false;
        // }

        // if (totgeburtEigenschaft || equidenpassEigenschaft || rinderpassEigenschaft || ohrmarkeFehltEigenschaft) {
        //     if (Utils.isTrue(totgeburtEigenschaft?.Wert) || Utils.isTrue(equidenpassEigenschaft?.Wert) || Utils.isTrue(rinderpassEigenschaft?.Wert) || Utils.isTrue(ohrmarkeFehltEigenschaft?.Wert) || untersuchungOhrmarkeEigenschaft) {
        //         // Für ZTN, OFK etc. ist die Ohrmarke und das Geburtsdatum kein Pflichtfeld, wenn es sich um eine Totgeburt handelt.
        //         for (const eigenschaft of vo.auftragsposition.Eigenschaften) {
        //             // Merke die alten Werte, damit sie wiederhergestellt werden können, wenn Totgeburt wieder deaktiviert wird
        //             if (!eigenschaft.oldRegex) {
        //                 eigenschaft.oldRegex = eigenschaft.Regex;
        //             }

        //             if (!eigenschaft.oldSonderpruefung) {
        //                 eigenschaft.oldSonderpruefung = eigenschaft.Sonderpruefung;
        //             }

        //             if (eigenschaft.Regex) {
        //                 eigenschaft.Regex = null;
        //                 geaendert = true;
        //             }

        //             if (eigenschaft.Sonderpruefung) {
        //                 eigenschaft.Sonderpruefung = null;
        //                 geaendert = true;
        //             }
        //         }

        //         // Hier ebemfalls Ohrmarke und geburtsdatum ausblenden
        //         if (totgeburtEigenschaft && geburtsdatumEigenschaft) {
        //             geburtsdatumEigenschaft.isAusgeblendet = true;
        //         }

        //         if (totgeburtEigenschaft && ohrmarkeEigenschaft) {
        //             ohrmarkeEigenschaft.isAusgeblendet = true;
        //         }

        //         // Amtliche Untersuchung 
        //         if (amtlicheUntersuchungEigenschaft && untersuchungOhrmarkeEigenschaft) {
        //             // muss nun die Ohrmarke Rot angezeigt oder ausgeblendet werden 
        //             if (Utils.isTrue(amtlicheUntersuchungEigenschaft.Wert)) {
        //                 untersuchungOhrmarkeEigenschaft.isAusgeblendet = false;
        //                 geaendert = true;
        //             } else {
        //                 untersuchungOhrmarkeEigenschaft.isAusgeblendet = true;
        //                 untersuchungOhrmarkeEigenschaft.Regex = null;
        //                 geaendert = true;
        //             }
        //         }

        //     } else {
        //         // Stelle die alten Werte wieder her, wenn Totgeburt deaktiviert wird
        //         for (const eigenschaft of vo.auftragsposition.Eigenschaften) {
        //             if (eigenschaft.oldRegex && eigenschaft.oldRegex != eigenschaft.Regex) {
        //                 eigenschaft.Regex = eigenschaft.oldRegex;
        //                 geaendert = true;
        //             }

        //             if (eigenschaft.oldSonderpruefung && eigenschaft.oldSonderpruefung != eigenschaft.Sonderpruefung) {
        //                 eigenschaft.Sonderpruefung = eigenschaft.oldSonderpruefung;
        //                 geaendert = true;
        //             }
        //         }
        //     }
        // }

        // // TODO ausblenden

        // return geaendert;
    }
}

interface AuftragspositionVO {
    auftragsposition: AuftragspositionEx;
    artikel: Artikel;
    vertragsposition?: Vertragsposition;
    behaelter: BehaelterbewegungVO[];
    mengeUngueltig: boolean;
    gewichtUngueltig: boolean;
    MengeOption: MengeOptionTyp;
    StandardMenge: number;
    wiegungZuordnenAnzeigen: boolean;
    wiegenButtonAnzeigen: boolean;
    LaderaumAuswahlAktiv: boolean;
    suchtext: string;
    wiegenAktiv: boolean;
    isArtikelAenderbar: boolean;
    /** Löschen-Button anzeigen, siehe IAuftragdetails.istPositionLoeschbar() */
    isLoeschbar: boolean;
    seriennummernText?: string;
    mengeVariante: 'aenderbar' | 'standard-oder-null' | 'nicht-aenderbar';
}

interface BehaelterbewegungVO {
    name: string;
    aktion: 'stellen' | 'entleeren' | 'abziehen' | 'umsetzen' | 'direktbeladung';
    behaelterNr: string;
    manuelleNummer?: string;
    behaelterNrUngueltig?: boolean;
    isScan?: boolean;

    // Zum anzeigen von "NFC aktiv"
    aktiv?: boolean;

    // Soll der Abstellort ausgewählt werden?
    abstellortAktiv?: boolean;

    // Nur temporär fpr ionic-selectable
    abstellort?: AdresseEntity;

    // Adresse des Abstellorts
    abstellortKey?: string;
    zustand?: string; // voll / leer

    position?: GpsPosition;

    changed?: boolean;

    gescannteBehaelterNr?: string;
}

interface LaderaumVO {
    key: string;
    nummer: number;
    bezeichnung: string;
}

